module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJnbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLnN2Zz84OTg4OTY4ODE0N2JkNzU3NWQ2MzI3MTYwZDY0ZTc2MCI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 91
// module chunks = 0